import script from "./ImageCoursewareCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImageCoursewareCard.vue?vue&type=script&lang=ts&setup=true"

import "./ImageCoursewareCard.vue?vue&type=style&index=0&id=7b6bfe53&scoped=true&lang=css"
import "./ImageCoursewareCard.vue?vue&type=style&index=1&id=7b6bfe53&lang=less&scoped=true"
script.__scopeId = "data-v-7b6bfe53"

export default script